import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringLimited50',
    standalone: false
})

export class StringLimited50 implements PipeTransform {

    transform(str: string): string {
        if (str) {
            if (str.length <= 50) {
                return str;
            }
            
            return str.substring(0, 50) + '...';
        }

        return '';
    }
}